import { Playground } from '@/features/livekit-playground/components/playground/Playground'
import { ConfigProvider } from '@/features/livekit-playground/hooks/useConfig'
import { ConnectionProvider } from '@/features/livekit-playground/hooks/useConnection'
import '@/features/livekit-playground/styles/globals.css'

export function PlaygroundPage() {
  const livekitUrl = import.meta.env.VITE_LIVEKIT_URL || ''

  return (
    <div className="h-full w-full bg-background overflow-hidden pt-16">
      <ConfigProvider livekitUrl={livekitUrl}>
        <ConnectionProvider>
          <Playground />
        </ConnectionProvider>
      </ConfigProvider>
    </div>
  )
}
